import { Injectable } from '@angular/core';
import { Navigation } from 'app/core/navigation/navigation.types';
import { Observable, ReplaySubject } from 'rxjs';
import { isEqual } from 'lodash-es';
import { AuthService } from '../auth/auth.service';
import { environment } from "../../../environments/environment";

@Injectable({ providedIn: 'root' })
export class NavigationService {
    private _navigation: ReplaySubject<Navigation> = new ReplaySubject<Navigation>(1);

    constructor(
        private _authService: AuthService,
    ) {
    }

    get navigation$(): Observable<Navigation> {
        return this._navigation.asObservable();
    }

    get(): void {
        const userUiType = environment.user_ui_type;
        const payload = new FormData();

        this._authService.httpPostService("/system/menu/get", payload, 'menuData').subscribe(
            (response) => {
                if (userUiType === 2 || userUiType === 4) {
                    if (!Array.isArray(response)) {
                        response = [];
                    }

                    response.push({
                        id: 'linked-properties',
                        title: 'Linked Properties',
                        type: 'basic',
                        icon: 'heroicons_outline:users',
                        link: '/content/destinations/list/affiliates'
                    });

                    if (userUiType === 4) {
                        let dashboardGroup = response.find((item: any) => item.id === 'dashboards');
                        const hlLink = {
                            id: 'dashboards.gohighlevel',
                            title: 'Partner Portal',
                            type: 'basic',
                            icon: 'heroicons_outline:rocket-launch',
                            link: 'https://app.gohighlevel.com/',
                            target: '_blank',
                            externalLink: true
                        };

                        if (dashboardGroup) {
                            if (!dashboardGroup.children) {
                                dashboardGroup.children = [];
                            }
                            const exists = dashboardGroup.children.find((child: any) => child.id === hlLink.id);
                            if (!exists) {
                                dashboardGroup.children.push(hlLink);
                            }
                        } else {
                            dashboardGroup = {
                                id: 'dashboards',
                                title: 'Dashboard',
                                type: 'group',
                                children: [
                                    {
                                        id: 'dashboards.project',
                                        title: 'Home',
                                        type: 'basic',
                                        icon: 'heroicons_outline:home',
                                        link: '/dashboards/project'
                                    },
                                    hlLink
                                ]
                            };
                            response.unshift(dashboardGroup);
                        }
                    }
                }

                if (userUiType === 3 || userUiType === 4) {
                    let dashboardGroup = response.find((item: any) => item.id === 'dashboards');
                    const qrLink = {
                        id: 'marketing-qr-free-subscription',
                        title: 'QR Free Subscriptions',
                        type: 'basic',
                        icon: 'heroicons_outline:qr-code',
                        link: '/marketing/qr-code/free-subscriptions'
                    };

                    if (dashboardGroup) {
                        if (!dashboardGroup.children) {
                            dashboardGroup.children = [];
                        }
                        const exists = dashboardGroup.children.find((child: any) => child.id === qrLink.id);
                        if (!exists) {
                            dashboardGroup.children.push(qrLink);
                        }
                    } else {
                        dashboardGroup = {
                            id: 'dashboards',
                            title: 'Dashboard',
                            type: 'group',
                            children: [
                                {
                                    id: 'dashboards.project',
                                    title: 'Home',
                                    type: 'basic',
                                    icon: 'heroicons_outline:home',
                                    link: '/dashboards/project'
                                },
                                qrLink
                            ]
                        };
                        response.unshift(dashboardGroup);
                    }
                }

                let nagivationData = JSON.parse(localStorage.getItem("MENU_DATA"));
                if (!isEqual(nagivationData, response)) {
                    localStorage.setItem("MENU_DATA", JSON.stringify(response));
                    nagivationData = response;
                }
                return this._navigation.next({
                    compact: [],
                    default: nagivationData,
                    futuristic: [],
                    horizontal: []
                });
            });
    }
}
